import { LabelEnum } from '../types/enums';
import { Tool } from '@app/shared/utils';

export const mapToolToLabel = (link: Tool): LabelEnum =>
  ({
    [Tool.Rationing]: LabelEnum.DAILY_ALLOWANCE,
    [Tool.RenalDetect]: LabelEnum.RENAL_DETECT,
    [Tool.SmartReco]: LabelEnum.PRODUCT_FINDER,
    [Tool.RapidReco]: LabelEnum.RAPID_RECO,
    [Tool.WeightManagement]: LabelEnum.WEIGHT_MANAGEMENT,
  })[link];
